import {createStyles} from '@mantine/core';

// Shared dimmed uppercase section header used across the Agents page (e.g. "Active agents",
// "Paused agents", "Get started with an example"). Hoisted here so the styling stays consistent and
// cannot drift between components.
export const useRoutineSectionHeaderStyles = createStyles((theme) => ({
  sectionHeader: {
    fontSize: theme.fontSizes.sm,
    fontWeight: 600,
    color: theme.colors.gray[6],
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
}));
